import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';

interface Emits {
  (e: 'apply'): void;
}

export interface AdPreviewProps {
  title: string;
  displayLink: string;
  headline: string;
  body: string;
  call_to_action_type?: string;
  image_url: string;
  metrics?: Array<{ name: string; value: string }>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcPreviewAdCard.ts',
  props: {
    title: null,
    displayLink: { default: 'Display Link' },
    headline: null,
    body: null,
    call_to_action_type: null,
    image_url: null,
    metrics: null
  },
  emits: ["apply"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'apply'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emits, CcIcon }
}

})